module.exports = __webpack_public_path__ + "static/media/btn_back.409d848b.svg";